export default __webpack_public_path__ + "d01f75b764a3b4abbed89ecdbadb99e5.png";